<label *ngIf="title" class="checkbox-group-title">
  {{title}}
  <span class="required" *ngIf="isRequired"></span>
</label>
<ng-content></ng-content>

